import React, { Component } from 'react'
import { connect } from 'react-redux'

class Header extends Component {
  toggleSidebarState () {
    this.props.dispatch({
      type: 'SET_SIDEBAR_STATE',
      payload: !this.props.sidebar
    })
  }
  render () {
    return (
      <nav className='navbar navbar-fixed-top navbar-default'>
        <div className='container-fluid'>
          <div className='navbar-header'>
            <a className='navbar-brand'><img src='/static/flowlogo.svg' width='40' height='40' /><span>Installation</span></a>
          </div>
          <ul className='nav navbar-nav navbar-nav-first'>
            <li>
              <a className='header-button' onClick={(e) => this.toggleSidebarState()}><i className='fa fa-bars' /></a>
            </li>
          </ul>
          <ul className='nav navbar-nav navbar-right'>
            <li data-tip='Logout'>
              <a className='header-button' onClick={(e) => {
                window.localStorage.clear()
                window.location.reload()
              }}><i className='fa fa-unlock-alt' /></a>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}
// eslint-disable-next-line
Header = connect(state => state.siteReducer)(Header)
export default Header



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/components/core/Header.js